<template>
    <section class="about">
        <div class="wrap">
            <div class="mark">
                <div class="mark-core">UC</div>
                <div class="mark-line"></div><span>UNITECORE / EST.</span>
            </div>
            <div class="copy">
                <div class="kicker">09 / ABOUT UNITECORE</div>
                <h2>Technology works<br>better when it <em>connects.</em></h2>
                <p>UniteCore brings infrastructure, data, security, analytics and consulting together to help
                    organizations create resilient, connected and future-ready technology environments.</p>
                <router-link to="/about" class="about-link">
                    <span>Discover UniteCore</span>
                    <i class="bi bi-arrow-right"></i>
                </router-link>
            </div>
        </div>
    </section>
</template>
<script>export default { name: 'AboutSection' }</script>
<style scoped>
.about {
    background: #f3f1eb;
    padding: 85px 0 45px;
}

.wrap {
    width: min(1220px, calc(100% - 42px));
    margin: auto;
    display: grid;
    grid-template-columns: .8fr 1.2fr;
    gap: 110px;
    align-items: center
}

.mark {
    min-height: 420px;
    background: #111315;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative
}

.mark-core {
    width: 155px;
    height: 155px;
    border: 2px solid #f5820b;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font: 700 48px 'Space Grotesk';
    color: #f5820b
}

.mark-line {
    width: 1px;
    height: 70px;
    background: #555;
    margin: 18px 0
}

.mark span {
    font: 700 12px Inter;
    letter-spacing: .2em;
    color: #888;
}

.kicker {
    color: #f5820b;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: .15em
}

.copy h2 {
    font: 700 clamp(45px, 5vw, 70px)/.95 'Space Grotesk';
    letter-spacing: -.055em;
    margin: 22px 0
}

.copy h2 em {
    font-style: normal;
    color: #f5820b
}

.copy p {
    max-width: 590px;
    color: #333835;
    line-height: 1.9
}

.about-link {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    margin-top: 28px;
    padding-bottom: 12px;
    color: #111;
    text-decoration: none;
    font-size: 15px;
    font-weight: 800;
    font-family: 'Space Grotesk', sans-serif;
    border-bottom: 2px solid #f5820b;
    transition: all .35s ease;
}

.about-link span {
    transition: color .35s ease, text-shadow .35s ease;
}

.about-link i {
    color: #f5820b;
    font-size: 16px;
    transition: transform .35s ease, filter .35s ease;
}

.about-link:hover {
    color: #f5820b;
    text-shadow: 0 0 12px rgba(245, 130, 11, .55), 0 0 24px rgba(245, 130, 11, .3);
    box-shadow: 0 4px 18px rgba(245, 130, 11, .6);
}

.about-link:hover i {
    transform: translateX(6px);
    filter: drop-shadow(0 0 8px rgba(245, 130, 11, .85));
}

@media(max-width:850px) {
    .about {
        padding: 65px 0 35px;
    }

    .wrap {
        grid-template-columns: 1fr;
        gap: 55px
    }

    .mark {
        min-height: 340px;
        max-width: 500px
    }
}
</style>